import {
  CRUDLayout
} from "components"
import {
  Button,
  ButtonApprove,
  ButtonBack,
  ButtonReject,
  ButtonUpdate,
  DataStatus,
  TextArea,
  TextEditor,
} from "components2"
import { Form, Formik } from "formik"
import { useModalConfirm } from "hooks2"
import { useEffect, useState } from "react"
import { Card } from "react-bootstrap"
import { IoWarning } from "react-icons/io5"
import { useParams } from "react-router-dom"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import PermintaanPerubahaDataApi from "./api/PermintaanPerubahaDataApi"
import { ListPerubahanData, ModalDetailItemPerubahanData } from "./components"
import { DetailPermintaanPerubahanData } from "./components/DetailPermintaanPerubahanData"
import { useGetSinglePermintaanPerubahanData } from "./hooks"
import { submitMapper } from "./utils"

export const PermintaanPerubahaDataDetail = ({ setNavbarTitle }) => {
  const history = useHistory()
  const modalConfirm = useModalConfirm()
  const { id_permintaan_perubahan_data_master } = useParams()

  const detail = useGetSinglePermintaanPerubahanData({ id_permintaan_perubahan_data_master })

  const data = detail.data?.data?.data

  const [modal, setModal] = useState({
    type: "CREATE",
    show: false,
    data: null,
    index: null
  })

  const dismissModal = (resetForm) => {
    if (resetForm) resetForm()

    setModal({ data: null, index: null, show: false, type: "" })
  }

  const formInitialValues = {
    tgl_permintaan_perubahan_data_master: data?.tgl_permintaan_perubahan_data_master,
    no_permintaan_perubahan_data_master: data?.no_permintaan_perubahan_data_master,
    urgensi: data?.urgensi,
    deskripsi: data?.deskripsi,
    detail: data?.detail,
    status: data?.status,
    status_approval: "",
    catatan_internal: data?.catatan_internal ?? "",
    catatan_tindakan: data?.catatan_tindakan ?? "",
  }

  const onSubmitForm = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true)

    await modalConfirm.trigger({
      type: 'create',
      customTextHeader: ' ',
      title: 'Konfirmasi permintaan data?',
      customButtonText: "Submit",
      component: (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <IoWarning size={100} className="mb-1 text-danger" />
          <div className="mb-3 d-flex flex-column align-items-center justify-content-center">
            <small
              className="font-weight-bold"
              style={{ fontSize: 14, color: 'var(--bs-danger)' }}>
              Apakah anda yakin ingin memproses permintaan ini?
            </small>
          </div>
        </div>
      ),
      onSubmit: async () => {
        modalConfirm.loading()

        const finalValue = submitMapper(values)

        PermintaanPerubahaDataApi.approve(finalValue)
          .then(() =>
            modalConfirm.infoSuccess({
              title: 'Data permintaan berhasil diproses',
              customTextInfoDetail: 'Data telah tersimpan ke database',
              size: 'md',
              onHide: () => {
                resetForm()
                modalConfirm.close()
                history.replace(
                  '/rqm/support/permintaan-pengubahan-data'
                )
              },
            })
          )
          .catch(({ response }) => {
            modalConfirm.infoError({
              title: 'Permintaan gagal diproses',
              customTextInfoTitle: 'Penyebab Kegagalan:',
              customTextInfoDetail: response?.data?.message,
            })
          })
      },
      onHide: () => modalConfirm.close(),
    })
  }

  useEffect(() => setNavbarTitle("Permintaan Perubahan Data"), [])

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadButtonSection>
          <ButtonBack size="md" icon onClick={() => history.goBack()} />
        </CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {detail?.isLoading ? (
        <Card className="mt-4">
          <Card.Body>
            <DataStatus loading loadingText="Memuat data..." />
          </Card.Body>
        </Card>

      ) : (
        <Formik
          enableReinitialize
          initialValues={formInitialValues}
          onSubmit={onSubmitForm}
        >
          {
            ({ values, errors, touched, setFieldValue, handleSubmit, setValues, handleChange }) => {
              return (
                <Form>
                  <Card className="mt-4">
                    <Card.Body>
                      <DetailPermintaanPerubahanData />
                    </Card.Body>
                  </Card>

                  <Card className="mt-4">
                    <Card.Header className="font-weight-bold">List Perubahan Data</Card.Header>
                    <Card.Body>
                      <ListPerubahanData
                        showDetailButton
                        showDeleteButton={false}
                        showUpdateButton={false}
                        data={values.detail}
                        onClickDetail={(data, index) => setModal({ show: true, type: "DETAIL", data, index })}
                      />
                    </Card.Body>
                  </Card>

                  {["REJ", "DON"].includes(data?.status) ? null : (
                    <Card className="mt-4">
                      <Card.Header className="font-weight-bold">Catatan</Card.Header>
                      <Card.Body>
                        <TextEditor
                          label="Catatan Internal"
                          name="catatan_internal"
                          value={values.catatan_internal}
                          onChange={(e) => setValues(prev => ({ ...prev, catatan_internal: e }))}
                          height={300}
                          error={Boolean(errors.catatan_internal && touched.catatan_internal)}
                          errorText={touched.catatan_internal && errors.catatan_internal}
                        />

                        <TextArea
                          label="Catatan Tindakan Permintaan"
                          name="catatan_tindakan"
                          rows={5}
                          value={values.catatan_tindakan}
                          onChange={handleChange}
                          error={errors.catatan_tindakan && touched.catatan_tindakan && true}
                          errorText={touched.catatan_tindakan && errors.catatan_tindakan}
                        />

                        <div style={{ gap: 12 }} className="mt-3 d-flex justify-content-end align-items-center">
                          {buttonAction({ status: data?.status, setFieldValue, handleSubmit })}
                        </div>
                      </Card.Body>
                    </Card>
                  )}


                  <ModalDetailItemPerubahanData
                    modal={modal}
                    dismissModal={dismissModal}
                  />
                </Form>
              )
            }}
        </Formik >
      )}
    </CRUDLayout >
  )
}

function buttonAction({ status, setFieldValue, handleSubmit }) {
  if (status === "PEN") {
    return (
      <>
        <Button
          variant="info"
          text="EVALUATION"
          onClick={() => {
            setFieldValue("status_approval", "EVA")
            handleSubmit()
          }}
        />

        <ButtonUpdate
          text="ON PROGRESS"
          onClick={() => {
            setFieldValue("status_approval", "ONP")
            handleSubmit()
          }}
        />

        <ButtonReject
          onClick={() => {
            setFieldValue("status_approval", "REJ")
            handleSubmit()
          }}
        />
      </>
    )
  }

  if (status === "EVA") {
    return (
      <>
        <ButtonUpdate
          text="ON PROGRESS"
          onClick={() => {
            setFieldValue("status_approval", "ONP")
            handleSubmit()
          }}
        />

        <ButtonReject
          onClick={() => {
            setFieldValue("status_approval", "REJ")
            handleSubmit()
          }}
        />
      </>
    )
  }

  if (status === "ONP") {
    return <>
      <ButtonReject
        onClick={() => {
          setFieldValue("status_approval", "REJ")
          handleSubmit()
        }}
      />

      <ButtonApprove
        text="DONE"
        onClick={() => {
          setFieldValue("status_approval", "DON")
          handleSubmit()
        }}
      />
    </>
  }
}
